import {useState, useEffect} from 'react';
import {
    BrowserRouter as Router,
    Switch,
    Route,
    Redirect,
} from "react-router-dom";
import {useAlert} from 'react-alert';
import {getProviderInfo, updateProgress} from './api/provider'
import LoginPage from "./pages/LoginPage";
import ErrorPage from "./pages/ErrorPage";
import {Container} from "@material-ui/core";
import {makeStyles} from "@material-ui/core/styles";
import OverviewPage from "./pages/OverviewPage";
import EditLogoPage from "./pages/EditLogoPage";
import ActivitiesPage from "./pages/ActivitiesPage";
import BranchesPage from "./pages/BranchesPage";
import GuidelinesPage from "./pages/GuidelinesPage";
import ThankYouPage from "./pages/ThankYouPage";
import HeaderBar from './components/HeaderBar';
import SubmitPage from './pages/SubmitPage';
import {Loading} from './components/Loading'

const useStyles = makeStyles((theme) => ({
    root: {
        padding: theme.spacing(2),
        display: 'flex',
        flexDirection: 'column',
        minHeight: '100vh',
    },
}))

const getTokenFromSessionStorage = () => {
    const token = sessionStorage.getItem('token');
    if (!token) {
        return null;
    }
    return token;
}

const Page = ({activeStep, ...props}) => {
    switch (activeStep) {
        case 0:
            return <GuidelinesPage {...props} />
        case 1:
            return <EditLogoPage {...props} />
        case 2:
            return <ActivitiesPage {...props} />
        case 3:
            return <BranchesPage {...props} />
        case 4:
            return <OverviewPage {...props} />
        case 5:
            return <SubmitPage {...props} />
        default:
            return null;
    }
}


function App() {
    const classes = useStyles();
    const [token, setToken] = useState(getTokenFromSessionStorage());
    const [loading, setLoading] = useState(false);
    const [activeStep, setActiveStep] = useState(0);
    const [data, setData] = useState(null);
    const [completedSteps, setCompletedSteps] = useState([]);
    const [completed, setCompleted] = useState(false);
    const [pageParams, setPageParams] = useState({});
    const alert = useAlert();

    const loggedIn = !!token;

    useEffect(() => {
        if (!!token && data == null) {
            setLoading(true);
            getProviderInfo(token).then(data => {
                setData(data);
                setCompletedSteps(data.completedSteps)
                setActiveStep(Math.max(...data.completedSteps, 0))
            }).catch(() => setToken(null))
                .finally(() => setLoading(false))
        }
    }, [token, data])


    const navigateToPage = (pageIndex, pageParams) => {
        console.log("navigate, ", pageIndex, pageParams)
        setPageParams(pageParams)
        setActiveStep(Math.min(5, pageIndex))
    }


    const onStepForward = async () => {
        try {
            // let this happen in background
            // setLoading(true);
            if (completedSteps.indexOf(activeStep) === -1) {
                setCompletedSteps((steps) => [...steps, activeStep]);
            }
            setActiveStep(Math.min(5, activeStep + 1))
            setPageParams({});
            const notes = [];
            notes.push(data.provider.note);
            data.branches.forEach(b => notes.push(b.note))
            data.activities.forEach(a => notes.push(a.note))
            console.log(notes)

            const promise = updateProgress({
                completedSteps,
                notes: notes.filter(x => !!x),
            }, token)

            if (activeStep === 5) {
                setLoading(true);
                await promise;
                setLoading(false);
                setCompleted(true);
                sessionStorage.clear();
                setToken(null);
                setData(null);
            }
        } catch (e) {
            alert.show("failed to sync progress");
        } finally {
            setLoading(false);
        }
    }
    const onStepBackward = () => {
        console.log(activeStep);
        setActiveStep(Math.max(0, activeStep - 1))
    }


    return (
        <Router>
            <Container maxWidth={false} className={classes.root} >
                {loading && <Loading />}
                <Switch>
                    <Route path="/l/:token" exact>
                        <LoginPage onLogin={(token, data) => {setToken(token); setData(data)}} />
                    </Route>
                    <Route path="/error" exact>
                        <ErrorPage />
                    </Route>
                    <Route path="/thank-you" exact>
                        <ThankYouPage />
                    </Route>
                    {completed && <Redirect to="/thank-you" />}
                    {loggedIn && (<Route path="/home" exact>
                        <HeaderBar activeStep={activeStep} setActiveStep={setActiveStep} completedSteps={completedSteps} />
                        <Page
                            data={data}
                            token={token}
                            activeStep={activeStep}
                            onUpdate={setData}
                            onLoading={(s) => setLoading(s)}
                            pageParams={pageParams}
                            navigateToPage={navigateToPage}
                            onPrev={onStepBackward}
                            onNext={onStepForward} />
                    </Route>)}
                    <Redirect to={loggedIn ? "/home" : "/error"} />
                </Switch>
            </Container >
        </Router>
    )

}

export default App;
